import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupLogin = () => {
  //page hook
  const { t } = useTranslation();

  return {
    email: Yup.string()
      .email()
      .required(
        t("validation.required", {
          email: t("page.email"),
        })
      ),
    password: Yup.string()
      .required(
        t("validation.required", {
          password: t("page.password"),
        })
      )
      .min(3, "Too Short!"),
  };
};
